import { Magic, SupportedLocale } from "magic-sdk";

const MAGIC_API_KEY: string = import.meta.env.VITE_MAGIC_API_KEY as string;
const RPC_URL: string = import.meta.env.VITE_RPC_URL as string;
const NETWORK_ID: number = import.meta.env.VITE_NETWORK_ID as number;

// Custom node configuration for Alchemy RPC URL
const customNodeOptions = {
  rpcUrl: RPC_URL, // Your Alchemy RPC URL
  chainId: NETWORK_ID, // Chain ID for the network
};

// Get the current locale from localStorage or use the browser's locale
const userLocale = localStorage.getItem("i18nextLng");
// Create a supported locale object - Magic expects specific locale values
// Default to German if the locale is not supported
const currentLocale = (userLocale === "de" || userLocale === "en" ? userLocale : "de") as SupportedLocale;

// Initialize Magic instance with network configuration and locale
const magic = new Magic(MAGIC_API_KEY, {
  network: customNodeOptions,
  locale: currentLocale, // Add locale configuration
});

// Preload Magic iframe assets
magic.preload();

export default magic;
